import { render, staticRenderFns } from "./medicinal.vue?vue&type=template&id=5bad1b3a&scoped=true&"
import script from "./medicinal.vue?vue&type=script&lang=js&"
export * from "./medicinal.vue?vue&type=script&lang=js&"
import style0 from "./medicinal.vue?vue&type=style&index=0&id=5bad1b3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bad1b3a",
  null
  
)

export default component.exports